import { render, staticRenderFns } from "./addpayment_gift.vue?vue&type=template&id=21fa6cef&"
import script from "./addpayment_gift.vue?vue&type=script&lang=js&"
export * from "./addpayment_gift.vue?vue&type=script&lang=js&"
import style0 from "./addpayment_gift.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports